import { styled } from 'styled-components';
import { verticalFadeIn, verticalFadeOut } from '../../../../theme/animations.js';
import { ANIMATION_DURATION_MS } from './constants.js';
export const FloatingWrapper = styled.div `
  z-index: ${({ $zIndex }) => $zIndex};
  ${({ theme }) => theme.shadows.large};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.grey00_6};
  overflow: hidden;
  animation: ${({ $visible, $isTop }) => ($visible ? verticalFadeIn($isTop) : verticalFadeOut($isTop))} ${ANIMATION_DURATION_MS}ms ease
    forwards;
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
`;
export const ReferenceWrapper = styled.div `
  display: grid;
`;
